// extracted by mini-css-extract-plugin
module.exports = {"friends":"Friends_friends__3Lbpk","header":"Friends_header__2cdCi","friends__container":"Friends_friends__container__eQ7DM"};